<div class="container-fluid mt-4">
  <form novalidate [formGroup]="wellHookupForm">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Project Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input type="text" class=" k-textbox form-control" formControlName="ProjectWellCount" readonly>
        </div>
      </div>
      <div class="col-md-8">
        <button type="button" style="float: right;" kendoButton themeColor="primary" [svgIcon]="icons.refresh" [buttonLoading]="loading" [disabled]="loading" (click)="getWellHookupParameters(true)">Refresh Parameters</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label>ESP Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input type="text" class=" k-textbox form-control" formControlName="ESPWellCount" readonly>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Gas Lift Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input type="text" class=" k-textbox form-control" formControlName="GasLiftWellCount" readonly>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>HPGL Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input type="text" class=" k-textbox form-control" formControlName="HPGLWellCount" readonly>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>ESP-7 Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input type="text" class=" k-textbox form-control" formControlName="ESP7WellCount" readonly>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>ESP-HR Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input type="text" class=" k-textbox form-control" formControlName="ESPHRWellCount" readonly>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Dual Flow Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input type="text" class=" k-textbox form-control" formControlName="DualFlowWellCount" readonly>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Above Grade Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input type="number" class=" k-textbox form-control" formControlName="AboveGradeWellCount" readonly>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Below Grade Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input type="number" class=" k-textbox form-control" formControlName="BelowGradeWellCount" readonly>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Pad Visit Type</label>
          <kendo-dropdownlist class="form-control" [style.width.%]="100" [data]="dCellarPadVisitTypes" [textField]="'Description'" formControlName="CellarPadVisitTypeId" [valueField]="'CellarPadVisitTypeId'" [valuePrimitive]="true">
          </kendo-dropdownlist>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Tank Battery Design</label>
          <kendo-dropdownlist class="form-control" [style.width.%]="100" [data]="dTankBatteryDesigns" [textField]="'Description'" formControlName="AssociatedTankBatteryDesignId" [valueField]="'TankBatteryDesignId'" [valuePrimitive]="true">
          </kendo-dropdownlist>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Located on Tank Battery Pad</label>
          <kendo-dropdownlist class="form-control" [style.width.%]="100" [data]="yesNoResponse" [textField]="'text'" formControlName="IsLocatedOnTankBatteryPad" [valueField]="'value'" [valuePrimitive]="true">
          </kendo-dropdownlist>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-md-2">
            <div class="form-group">
              <label for="wellToEdgeOfPadDistance">Well to Edge of Pad Distance(ft)</label>
              <input id="wellToEdgeOfPadDistance" type="number" class=" k-textbox form-control" formControlName="WellToEdgeOfPadDistance">
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>